import { STRIPE_3DS_COMPLETE_MESSAGE_NAME } from '#app/constants/stripe.js';
import { useMount } from '@contra/react-hooks/useMount';

export const Page = () => {
  useMount(() => {
    window.top?.postMessage(STRIPE_3DS_COMPLETE_MESSAGE_NAME);
  });

  return null;
};
